import { render, staticRenderFns } from "./ControlAccesos.vue?vue&type=template&id=1ac934f4&scoped=true"
import script from "./ControlAccesos.vue?vue&type=script&lang=js"
export * from "./ControlAccesos.vue?vue&type=script&lang=js"
import style0 from "./ControlAccesos.vue?vue&type=style&index=0&id=1ac934f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac934f4",
  null
  
)

export default component.exports